import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const VehiclePlate = styled.div`
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 15rem;
    min-height: 5.5rem;
    padding-bottom: 0.75rem;
    border: 2px solid ${Colors.commons.gray};
    border-radius: 0.625rem;
    position: relative;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.15s ease, transform 0.15s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
        transform: translateY(-2px);
    }
`;

export const BlueBar = styled.div`
    background-color: ${Colors.stripes.blue};
    position: absolute;
    top: 0;
    height: 0.875rem;
    width: 100%;
    border-radius: 0.5rem 0.5rem 0 0;
`;

export const Text = styled.div`
    margin-top: 1rem;
    font-size: 2.25rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: ${Colors.commons.black};
`;

export const SubText = styled.div`
    font-size: 0.7rem;
    font-weight: 500;
    color: ${Colors.commons.darkGray};
    text-align: center;
    padding: 0 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 14rem;
    margin-top: 0.15rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
`;

export const StatusText = styled.div<{ $hasStatus: boolean }>`
    font-size: 0.65rem;
    font-weight: 600;
    text-align: center;
    padding: 0.15rem 0.6rem;
    border-radius: 999px;
    margin-top: 0.4rem;
    max-width: 13rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: ${({ $hasStatus }) =>
        $hasStatus ? Colors.primary[100] + "1A" : Colors.commons.gray};
    color: ${({ $hasStatus }) =>
        $hasStatus ? Colors.primary[100] : Colors.commons.darkGray};
    border: 1px solid ${({ $hasStatus }) =>
        $hasStatus ? Colors.primary[100] + "55" : "transparent"};
`;
